import angular from 'angular';

import '../../core/main/factory/feature';
import '../../main/factory/authentication';
import '../../main/factory/instore';
import './barcode/controller';
import './card/controller';

angular.module("merchant.application.page.inStore", [
]).controller("merchant.application.page.inStore.controller", [
    "$rootScope", "$scope", "$controller", "$location", "$q",
    "merchant.application.main.factory.authentication",
    "merchant.application.main.factory.instore",
    "core.application.main.factory.feature",
    function($rootScope, $scope, $controller, $location, $q, Authentication, Instore, Feature) {
        $controller("merchant.application.page.controller", {$scope: $scope});

        var featurePromise = Feature.retrieveFeatureFlagPromise("pos-card-portal-enabled", false);
        $q.when(featurePromise).then(function(result) {
            if (result) {
                $rootScope.headerMinor = Instore.header();
            } else {
                $rootScope.headerMinor = Instore.featureDisabledHeader();
            }
        });
    }
]);
